import { reactive } from 'vue'

const scrollState = reactive({
	isScrollingUp: false,
	headerHeight: 0,
	MIN_SCROLL_DISTANCE: 200, // Generated by experience
	currentScrollPos: 0,
})

export default scrollState
